/**
 * Rendu Twemoji — emojis SVG identiques sur tous les OS/navigateurs.
 * CDN jsDelivr, aucune dépendance npm supplémentaire.
 */

export function getTwemojiUrl(emoji) {
  const codepoints = [...emoji]
    .map(c => c.codePointAt(0).toString(16))
    .filter(cp => parseInt(cp, 16) !== 0xfe0f) // supprime le variation selector
    .join('-')
  return `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/${codepoints}.svg`
}

export function TwemojiImg({ emoji, size = 32, className = '' }) {
  return (
    <img
      src={getTwemojiUrl(emoji)}
      alt={emoji}
      width={size}
      height={size}
      className={`inline-block select-none ${className}`}
      draggable={false}
    />
  )
}
